import {CONFIG} from "../../config";
import axios from "axios";

async function getPublicData(signal) {
    const location = CONFIG.API_URL + "nutitee/getPublicData";
    const settings = {
        signal: signal,
        headers: {
            'Content-Type': 'application/json',
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return null;
    }
}

export default getPublicData;